<template>
    <div>
        <img src="http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2NZFvooF.png" width="100%" />
        <div class="task" v-for="task in showTaskList" :key="task.id" v-if="showTaskList&&showTaskList.length!=0">
            <van-row>
                {{task.name}}
            </van-row>

            <van-row justify="space-around">
                <van-col span="18">
                    <van-row>
                        {{task.ruleDesc}}
                    </van-row>
                </van-col>
                <van-col span="6" style="text-align:right">
                    <van-button round size="small" @click="queryTaskShare(task)" style="width:6rem;">
                        点击领码
                    </van-button>
                </van-col>
            </van-row>

            <van-row justify="space-around" v-if="task.ext1">
                <van-col span="18">
                    <van-row>
                        {{task.ext1}}
                    </van-row>
                </van-col>
                <van-col span="6" style="text-align:right">
                    <van-button round size="small" @click="kuaishouZhuboDialogVisible=true" style="width:6rem;">
                        点击关注
                    </van-button>
                </van-col>
            </van-row>
        </div>

        <van-dialog v-model="dialogVisible">
            <div class="title">{{jobInfo.name}}</div>
            <div class="qrCode">
                <vue-qr :margin="0" :text="jobInfo.jobQrCode" :logoScale="0.25"
                        v-if="jobInfo.jobQrCode" :size="185" :callback="qrCallback"></vue-qr>
            </div>
        </van-dialog>

        <van-dialog v-model="kuaishouZhuboDialogVisible">
            <img src="http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2Nc0fGBK.jpg" width="100%" />
        </van-dialog>
    </div>
</template>

<script>
    import tuandui from '@/assets/images/tuandui.png';
    import vueQr from 'vue-qr'
    import mainAPI from '@/api/main';
    import constantAPI from '@/api/constant';
    import wxShare from '@/utils/wxShareService';
    import pvuvAPI from '@/api/pvuv';

    export default {
        components: {
            vueQr
        },
        data() {
            return {
                tuandui: tuandui,
                query: {
                    traderId: this.$route.query.traderId,
                },
                showTaskList: [
                    // {
                    //     id: 75,
                    //     name: '美团APP新客1分购物',
                    //     ruleDesc: '下载美团-扫码注册-领取福利-支付1分钱购物',
                    // },
                    {
                        id: 90,
                        name: '京东金融新客8元话费红包',
                        ruleDesc: '扫码-输入手机号码-下载金融APP-领取话费红包-绑卡使用红包',
                    },
                    {
                        id: 88,
                        name: '淘宝特价版5元购物红包',
                        ruleDesc: '使用淘宝扫码-下载特价版-打开后淘宝登陆-5元券-下单',
                    },
                    {
                        id: 93,
                        name: '快手新客1元买10元货',
                        ruleDesc: '下载快手极速版-登陆-绑定微信-扫一扫绑定推广码-1元购页面-完成首购',
                        ext1: '快手扫码关注主播',
                        img: 'http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2Nc0fGBK.jpg',
                    },
                    {
                        id: 46,
                        name: '淘宝新客9.9元商品免费送',
                        ruleDesc: '下载APP-扫码-领券-0元下单',
                    },
                    {
                        id: 98,
                        name: '支付宝新客10元话费红包',
                        ruleDesc: '下载支付--扫码--注册领取红包--完成绑卡实名--核销红包（0元充值话费）',
                    },
                ],
                dialogVisible: false,
                kuaishouZhuboDialogVisible: false,
                jobInfo: {},
            }
        },
        methods: {
            qrCallback(url, id) {
            },
            queryTaskShare(task) {
                mainAPI.getInfoByTraderId(task.id, this.query.traderId).then((result) => {
                    this.jobInfo = result.data;
                    this.jobInfo.name = task.name;
                    this.dialogVisible = true;
                })
            },
        },
        created() {
        },
        mounted() {
            let shareInfo = {
                "imgUrl": "http://jho2o.oss-cn-beijing.aliyuncs.com/test/2Ns9IUQR.png",
                "title": "领福利",
                "desc": "红包优惠券、特价话费流量、免费实物礼品，这是一个只有福利的页面！",
                "link": window.location.href,
            };
            constantAPI.weChatShareConfig(shareInfo.link).then((result) => {
                wxShare.setWxConfig(result.data);
                wxShare.setShare(shareInfo);
            });
            pvuvAPI.addPv("benefit/postal", this.query.traderId).then((result) => {
            });
        }
    }

</script>

<style lang="scss" scoped>

    .task {
        padding: 1rem;
        margin: 1rem 1rem 0rem 1rem;
        border-left: 3px solid #ee9900;
        -moz-box-shadow: 0 0 10px #e5e5e5;
        -webkit-box-shadow: 0 0 10px #e5e5e5;
        box-shadow: 0 0 10px #e5e5e5;

        .van-col {
            font-size: 1.1rem;
            color: #8b8b8b;
            padding-top: 1rem;
            padding-bottom: 0.5rem;

            .van-button {
                background-color: #ee9900;
                color: #fff;
            }
        }
    }

    .title {
        font-size: 1.5rem;
        font-weight: bold;
        text-align: center;
        margin: 2rem;
    }

    .qrCode {
        margin: 1rem auto;
        width: 15.42rem;
        height: 15.42rem;
        background: white;

        img {
            width: 100%;
            height: 100%;
        }
    }

</style>
